import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Theme } from '../../../components';

import './Footer.scss';

interface Props {
  setIsFoodStatusOpen: (isOpen: boolean) => void;
  setIsDeleteOpen: (isOpen: boolean) => void;
  setIsSelectOpen: (isOpen: boolean) => void;
  setIsActionMenuOpen: (isOpen: boolean) => void;
  hasActiveTimer: boolean;
  isActionMenuOpen: boolean;
  isLoading: boolean;
}

const ActionMenu: FC<Props> = ({
  setIsFoodStatusOpen,
  setIsDeleteOpen,
  hasActiveTimer,
  setIsSelectOpen,
  isActionMenuOpen,
  setIsActionMenuOpen,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className='action-menu-container'>
      <div className='button-container'>
        <Button
          className='btn-add'
          onClickCallback={() => setIsActionMenuOpen(!isActionMenuOpen)}
          theme={!isActionMenuOpen ? Theme.INVERSE : Theme.SECONDARY}
          icon='Dots'
          isLoading={isLoading}>
          {t('lblMore')}
        </Button>
      </div>

      {isActionMenuOpen && (
        <div className='action-menu'>
          <Button onClickCallback={() => setIsDeleteOpen(true)} theme={Theme.PLAIN} icon='Trashcan'>
            {t('lblEmptyFoodLine')}
          </Button>
          <div className='hr' />
          {hasActiveTimer ? (
            <Button onClickCallback={() => setIsFoodStatusOpen(true)} theme={Theme.PLAIN} icon='Cutlery'>
              {t('lblChangeFoodItem')}
            </Button>
          ) : (
            <Button onClickCallback={() => setIsSelectOpen(true)} theme={Theme.PLAIN} icon='Cutlery'>
              {t('lblChangeFoodItem')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
